<div class="container-table">
  <mat-table
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
    matSortDirection="asc"
  >
    <ng-container matColumnDef="companyName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Razão social / Nome</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Razão social / Nome</span>
        <p class="label-desktop company-name" [title]="row?.companyName">
          {{ row?.companyName }}
        </p>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">CNPJ</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">CNPJ:</span>
        <span class="label-desktop label-data">
          {{ row?.cnpj | mask : "AA.AAA.AAA/AAAA-00" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="agencyNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Agência</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Agência:</span>
        <span class="label-desktop label-data">
          {{ row?.agencyNumber }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="spreadBanking">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Spread bancário</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Spread bancário:</span>
        <span class="label-desktop label-data">
          {{ row?.spreadBanking ? "Ativado" : "Desativado" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="spread">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Spread</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Spread:</span>
        <span class="label-desktop label-data">
          {{
            row?.spread == null
              ? "-"
              : (row?.spread * 100 | number : "1.2-2") + "%"
          }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tariff">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Tarifa</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Tarifa:</span>
        <span class="label-desktop label-data">
          {{
            row?.tariff == null
              ? "-"
              : (row?.tariff | currency : "BRL" : "symbol-narrow" : "1.2-2")
          }}
        </span>
      </mat-cell>
    </ng-container>

       <ng-container matColumnDef="institutionalSpread">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Spread OZ</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Spread OZ:</span>
        <span class="label-desktop label-data">
          {{
            row?.institutionalSpread == null
              ? "-"
              : (row?.institutionalSpread * 100 | number : "1.3-3") + "%"
          }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <p class="label-desktop">Ações</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <p
          class="tappable label-desktop label-action"
          (click)="openPartnerConfigModal(row)"
        >
          Configurar
        </p>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>

<mat-paginator
  class="custom-paginator"
  [pageIndex]="pageNumber"
  [pageSize]="pageSize"
  (page)="changePageEvent($event)"
  [pageSizeOptions]="[5, 10, 25, 100]"
  showFirstLastButtons
></mat-paginator>
